import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AuthProvider } from '@/contexts/AuthContext'
import { BranchProvider } from '@/contexts/BranchContext'
import { UiLocaleProvider } from '@/contexts/UiLocaleContext'

import App from './App.jsx'
import './index.css'

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw-pos.js`).catch(() => {})
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <BranchProvider>
        <UiLocaleProvider>
          <App />
        </UiLocaleProvider>
      </BranchProvider>
    </AuthProvider>
  </StrictMode>,
)
